/**
 * Mapeia os IDs de tipos de produto para seus nomes resumidos padronizados
 * @param {number|string} id - O ID do tipo de produto
 * @return {string} O nome resumido padronizado do produto
 */
export const getNomeAbreviado = (id) => {
  const idStr = String(id);
  switch (idStr) {
    case '1': return 'P13';
    case '2': return 'P45';
    case '3': return 'P20';
    case '4': return 'P2';
    case '5': return 'P5';
    case '6': return 'P13 Vazio';
    case '7': return 'P8';
    case '9': return 'P13 Completo';
    case '10': return 'P45 Completo';
    default: return null; 
  }
};

/**
 * Formata um nome de tipo de produto baseado no objeto do produto
 * @param {Object} produto - O objeto do produto com propriedades tipo e peso
 * @return {string} Nome formatado do produto
 */
export const formatarNomeProduto = (produto) => {
  if (!produto) return '';
  
  const nomeResumido = getNomeAbreviado(produto.id);
  
  // Se tivermos um nome resumido mapeado, use-o
  if (nomeResumido) return nomeResumido;
  
  // Caso contrário, use o formato padrão
  return `${produto.tipo || ''} ${produto.peso ? `(${produto.peso}kg)` : ''}`;
};

/**
 * Formata a exibição de um produto na lista de produtos (objeto tipoproduto)
 * @param {Object} tipoProduto - O objeto tipoproduto com propriedades tipo e peso
 * @return {string} Exibição formatada do produto
 */
export const formatarExibicaoProduto = (tipoProduto) => {
  if (!tipoProduto) return '';
  
  const nomeResumido = getNomeAbreviado(tipoProduto.id);
  
  // Se tivermos um nome resumido mapeado, use-o
  if (nomeResumido) return nomeResumido;
  
  // Caso contrário, use o formato padrão
  return `${tipoProduto.tipo || ''} - ${tipoProduto.peso || 0} kg`;
};
